import React from "react";
import Hero from "./hero/logo";
import Details from './details/Details';
import LessonNominee from './lessonNominee/LessonNominee';
import MakeContact from './makeContact/MakeContact'
import VideoPromotion from './videoPromotion/VideoPromotion'
import About from "./about/about";
import VideoPromotionLahav from "./videoPromotionLahav/videoPromotionLahav";
import WhatWillBeLearned from "./whatWillBeLearned/whatWillBeLearned";


function Homepage(){
    return(
    <>
    {/* <Hero /> */}
    <VideoPromotion />
    <About />
    <LessonNominee />
    <Details />
    <WhatWillBeLearned />
    <VideoPromotionLahav />
    <MakeContact />
    </>
    )
}

export default Homepage